var map = {
	"./accompagnements.png": "3e0a",
	"./barasalades.png": "8c84",
	"./boissons.png": "1511",
	"./boissonschaudes.png": "d6a8",
	"./desserts.png": "111d",
	"./eggbar.png": "229f",
	"./entrees.png": "01ad",
	"./formules.png": "f600",
	"./fromages.png": "4a9b",
	"./fruits.png": "b0fa",
	"./gateaux.png": "dd6c",
	"./gourmandises.png": "45ea",
	"./pains.png": "75a2",
	"./plats.png": "b466",
	"./snacking.png": "75fc",
	"./viennoiseries.png": "9946"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "384d";